// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNWANTED VARIABLE
// MODFIED DATA : 10-09-2025

const RequestReportActionTypes = {
	/********************* FETCH REQUEST REPORT DETAILS START *********************** */
	FETCH_REQUEST_REPORT_DETAILS_START: 'fetch_request_report_details_start',
	FETCH_REQUEST_REPORT_DETAILS_SUCCESS: 'fetch_request_report_details_success',
	FETCH_REQUEST_REPORT_DETAILS_FAILURE: 'fetch_request_report_details_failure',
	FETCH_REQUEST_REPORT_DETAILS_RESPONSE_RESET: 'fetch_request_report_details_response_reset',
	FETCH_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED: 'fetch_request_report_details_response_changed',
	/********************* FETCH REQUEST REPORT DETAILS END *********************** */

	/********************* ADD REQUEST REPORT DETAILS START *********************** */
	ADD_REQUEST_REPORT_DETAILS_START: 'add_request_report_details_start',
	ADD_REQUEST_REPORT_DETAILS_SUCCESS: 'add_request_report_details_success',
	ADD_REQUEST_REPORT_DETAILS_FAILURE: 'add_request_report_details_failure',
	ADD_REQUEST_REPORT_DETAILS_RESPONSE_RESET: 'add_request_report_details_response_reset',
	ADD_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED: 'add_request_report_details_response_changed',
	/********************* ADD REQUEST REPORT DETAILS END *********************** */

	/********************* DELETE REQUEST REPORT DETAILS START *********************** */
	DELETE_REQUEST_REPORT_START: 'delete_request_report_start',
	DELETE_REQUEST_REPORT_SUCCESS: 'delete_request_report_success',
	DELETE_REQUEST_REPORT_FAILURE: 'delete_request_report_failure',
	DELETE_REQUEST_REPORT_RESET: 'delete_request_report_reset',
	DELETE_REQUEST_REPORT_CHANGED: 'delete_request_report_changed',
	/********************* DELETE REQUEST REPORT DETAILS END *********************** */
};
export default RequestReportActionTypes;
